import { render, staticRenderFns } from "./erro-conexao.vue?vue&type=template&id=ca396574&"
import script from "./erro-conexao.vue?vue&type=script&lang=js&"
export * from "./erro-conexao.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports